/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import GenerateAdtInfoImportFilePanelComponent from "./generateAdtInfoImportFilePanel.component";
import { exportAdtInfoForm } from "modules/serial-number/redux";
import { selectLoading } from "modules/notification";
import { unwrapResult } from "@reduxjs/toolkit";
import { getLang } from "app/feature/constants";

function GenerateAdtInfoImportFilePanelContainer({ handleBack }) {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.constant.languages);
  const token = useSelector((state) => state.session.accessToken);
  const isExporting = useSelector((state) =>
    selectLoading(state, exportAdtInfoForm.typePrefix)
  );

  const handleSubmit = async (values) => {
    let ranges = values.ranges.filter((range) => range.to.trim() !== "");

    dispatch(
      exportAdtInfoForm({
        token: token,
        ranges: ranges,
        type: values.type,
        supportedLanguages: values.languages.map((l) => l.code),
        fields: values.selectedIds,
        isSelectAllFields: values.isSelectAll,
      })
    )
      .then(unwrapResult)
      .then(() => handleBack());
  };

  const validate = (formik) => {
    let isValid = true;
    let overlap = false;

    formik.values.ranges.forEach((range, i) => {
      let rangeError = formik.values.errors.ranges;

      if (range.from.trim() === "" && range.to.trim() !== "") {
        rangeError[i] = {
          ...rangeError[i],
          from: getLang(lang, "message.error.FORM_VALIDATE_REQUIRED"),
        };
        formik.setFieldTouched(`ranges.${i}.from`);
        isValid = false;
      }

      if (formik.values.type === 1) {
        let from = getSnFormat(range.from);
        let to = getSnFormat(range.to);

        if (
          from[0] !== to[0] ||
          from[2] !== to[2] ||
          from[1].length !== to[1].length
        ) {
          rangeError[i] = {
            ...rangeError[i],
            to: getLang(lang, "message.error.INVALID_SERIAL_NUMBER_RANGE"),
          };
          formik.setFieldTouched(`ranges.${i}.to`);
          isValid = false;
        } else {
          from = Number(from[1]);
          to = Number(to[1]);
          // check if the sn is valid format with digit
          if (isNaN(from) || isNaN(to)) {
            if (isNaN(from)) {
              rangeError[i] = {
                ...rangeError[i],
                from: getLang(lang, "message.error.INVALID_SERIAL_NUMBER"),
              };
              formik.setFieldTouched(`ranges.${i}.from`);
            }
            if (isNaN(to)) {
              rangeError[i] = {
                ...rangeError[i],
                to: getLang(lang, "message.error.INVALID_SERIAL_NUMBER"),
              };
              formik.setFieldTouched(`ranges.${i}.to`);
            }
            isValid = false;
          } else if (from > to) {
            // check if the sn range is valid, from < to
            rangeError[i] = {
              ...rangeError[i],
              to: getLang(
                lang,
                "message.error.FORM_VALIDATE_SN_SELECTION_RANGES"
              ),
            };
            formik.setFieldTouched(`ranges.${i}.to`);
            isValid = false;
          }
        }
      }

      if (formik.values.type === 2) {
        let from = Number(range.from);
        let to = Number(range.to);

        if (range.from || range.to) {
          let temp = [...formik.values.ranges];
          temp.splice(i, 1);
          let overlapIdx = temp.findIndex(
            (r) =>
              (Number(r.from) <= from && to <= Number(r.to)) ||
              (Number(r.from) >= from && to >= Number(r.to)) ||
              Number(r.to) === from ||
              to === Number(r.from)
          );
          if (overlapIdx >= 0) {
            overlap = true;
            isValid = false;
          }
        }

        if (from > to) {
          rangeError[i] = {
            ...rangeError[i],
            to: getLang(
              lang,
              "message.error.FORM_VALIDATE_SN_SELECTION_RANGES"
            ),
          };
          formik.setFieldTouched(`ranges.${i}.to`);
          isValid = false;
        }
      }

      formik.setFieldValue("errors", {
        ranges: rangeError,
      });
    });

    formik.setFieldValue("hasOverlapped", overlap);

    return isValid;
  };

  const getSnFormat = (input) => {
    const regex = /^([A-Z]*)(0*\d+)([A-Z]*)$/;
    const matches = input.match(regex);

    if (!matches) {
      return [null, input, null];
    }

    // Extract the parts ensuring we return null for empty parts
    const prefix = matches[1] || null;
    const number = matches[2] || null;
    const suffix = matches[3] || null;

    return [prefix, number, suffix];
  };

  return (
    <>
      <GenerateAdtInfoImportFilePanelComponent
        handleSubmit={handleSubmit}
        lang={lang}
        handleBack={handleBack}
        isExporting={isExporting}
        validate={validate}
      />
    </>
  );
}

export default GenerateAdtInfoImportFilePanelContainer;
